import { useTheme } from "@cellectenergy/cellect-react-components";
import { useTranslation } from "react-i18next";
import {
  BoardItem,
  BoardItemBottom,
  BoardItemIcon,
  BoardSlider,
  BoardSliderInner,
} from "./BoardAbout.styles";
import { Box, Grid, Typography } from "@mui/material";

const BoardAbout = () => {
  const theme = useTheme();
  const { t } = useTranslation("global");

  const founders = [
    {
      name: "Leon Gosh",
      position: "Founder, Managing Director",
      image: "/assets/about/leon-gosh.webp",
      linkedIn: "https://www.linkedin.com/in/leon-gosh-78046299/",
    },
    {
      name: "Magnus Johansen",
      position: "Chairman of the Board",
      image: "/assets/about/magnus-johansen.webp",
      linkedIn: "https://www.linkedin.com/in/magjoh/",
    },
    {
      name: "Torkil S. Mogstad",
      position: "Board of Directors",
      image: "/assets/about/torkil-s-mogstad.webp",
      linkedIn: "https://www.linkedin.com/in/torkil-mogstad-06372/",
    },
    {
      name: "Håkon Tanem",
      position: "Board of Directors",
      image: "/assets/about/hakon-tanem.webp",
      linkedIn: "https://www.linkedin.com/in/h%C3%A5kon-tanem-b91149/",
    },
  ];

  return (
    <Box
      maxWidth={"1440px"}
      margin={{ lg: "0 auto" }}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: { xs: "2rem 0rem 0", md: "3rem 0", lg: "3rem 2rem" },
        gap: { xs: 3, md: 4 },
        backgroundColor:
          theme.palette.common.corporateColors?.primary.midNightBlue,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          textAlign: "left",
          alignItems: "left",
          paddingLeft: {
            xs: "1rem",
            lg: 0,
          },
        }}
      >
        <Grid container display={"flex"} justifyContent={"left"} gap={3}>
          <Grid item xs={12} md={9} lg={8} textAlign="left">
            <Typography
              variant="display-small"
              color={theme.palette.common.corporateColors.primary.white}
              fontWeight={500}
            >
              {t("about.board.title")}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <BoardSlider>
        <div className="">
          <BoardSliderInner>
            {founders.map((founder, index) => (
              <BoardItem
                key={index}
                href={founder.linkedIn}
                target="_blank"
                rel="noreferrer"
              >
                <img src={founder.image} alt={founder.name} />
                <BoardItemBottom>
                  <div>
                    <Typography
                      variant="title-large"
                      fontWeight={500}
                      display={"block"}
                      color={theme.palette.common.corporateColors.primary.white}
                    >
                      {founder.name}
                    </Typography>
                    <Typography
                      variant="body-large"
                      display={"block"}
                      letterSpacing={"0.5px"}
                      color={theme.palette.common.corporateColors.primary.white}
                    >
                      {founder.position}
                    </Typography>
                  </div>
                  <BoardItemIcon>
                    <svg
                      width="33"
                      height="34"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M30.183 1.257c1.214 0 2.286 1.071 2.286 2.357v27.357c0 1.286-1.072 2.286-2.286 2.286h-27.5c-1.214 0-2.214-1-2.214-2.286V3.614c0-1.286 1-2.357 2.214-2.357h27.5ZM10.112 28.685V13.471H5.397v15.214h4.715ZM7.754 11.328c1.5 0 2.715-1.214 2.715-2.714S9.254 5.828 7.754 5.828A2.79 2.79 0 0 0 4.97 8.614c0 1.5 1.214 2.714 2.785 2.714Zm20.143 17.357v-8.357c0-4.071-.928-7.285-5.714-7.285-2.286 0-3.857 1.285-4.5 2.5h-.071V13.47h-4.5v15.214h4.714v-7.5c0-2 .357-3.928 2.857-3.928 2.429 0 2.429 2.286 2.429 4v7.428h4.785Z"
                        fill="#52D4CC"
                      />
                    </svg>
                  </BoardItemIcon>
                </BoardItemBottom>
              </BoardItem>
            ))}
          </BoardSliderInner>
        </div>
      </BoardSlider>
    </Box>
  );
};

export default BoardAbout;
